import Splide from "@splidejs/splide";
import {Lightbox} from "./pswp.ts";

document.addEventListener("DOMContentLoaded", () => {
    const product_gallery_slides = document.querySelectorAll<HTMLElement>(".product_gallery-splide");

    product_gallery_slides.forEach(gallery => {
        const current_index = gallery.querySelector<HTMLElement>(".splide__nav .current-slide");
        const splide = new Splide(gallery, {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            gap: '0',
            arrows: true,
            pagination: false,
            lazyLoad: 'nearby',
            preloadPages: 1,
        });

        splide.on('mounted', () => {
            const track = gallery.querySelector<HTMLElement>('.splide__track');
            const list = gallery.querySelector<HTMLElement>('.splide__list');
            if (track) track.style.overflow = '';
            if (list) list.style.transform = '';

            new Lightbox(gallery);

            const changeSlideByVariation = (value: number) => {
                if (value) {
                    const related_slide = splide.Components.Elements.slides.find(slide => {
                        return Number(slide.dataset.variationId) === value;
                    });

                    if (related_slide) {
                        const index = splide.Components.Elements.slides.indexOf(related_slide);
                        if (index !== -1) {
                            splide.go(index);
                        }
                    }
                }
            };

            const variation_id_input = document.querySelector<HTMLInputElement>('form.variations_form input.variation_id');
            if (variation_id_input && variation_id_input.value) {
                changeSlideByVariation(Number(variation_id_input.value));
            }

            window.addEventListener('woocommerce_variation_changed', (e: any) => {
                const variationId = e.detail?.variationId;
                if (variationId) {
                    changeSlideByVariation(Number(variationId));
                }
            });
        });

        if (current_index) {
            splide.on('move', () => {
                current_index.textContent = String(splide.index + 1);
            });
        }

        splide.mount();
    });
});

window.addEventListener("load", () => {
    const topbar_slide = document.querySelector<HTMLElement>(".top-bar-splide");
    const review_splides = document.querySelectorAll<HTMLElement>('.splide-reviews');

    review_splides?.forEach(reviews => {
        const splide = new Splide(reviews, {
            type: 'loop',
            perPage: 3,
            arrows: true,
            pagination: false,
            perMove: 1,
            gap: '20px',
            breakpoints: {
                575: {
                    perPage: 1,
                    gap: 0,
                },
                991: {
                    perPage: 2
                },
            }
        });


        splide.mount();
    });

    if (topbar_slide) {
        let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const splide = new Splide(topbar_slide, {
            type: 'fade',
            rewind: true,
            dir: 'ttb',
            drag: false,
            autoplay: true,
            interval: 3000,
            pauseOnHover: false,
            pauseOnFocus: false,
            perPage: 1,
            perMove: 1,
            gap: '0',
            arrows: false,
            pagination: false,
        });

        if (windowWidth <= 991) {
            splide.mount();
        }

        window.addEventListener('resize', () => {
            windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (windowWidth <= 991) {
                if (!splide.state.is(Splide.STATES.MOUNTED)) {
                    splide.mount();
                }
            } else {
                if (!splide.state.is(Splide.STATES.DESTROYED)) {
                    splide.destroy();
                }
            }
        })
    }
});
